import { Save } from 'lucide-react';
import { Spinner } from '@systemdox/ui';

interface SaveToRepoButtonProps {
  saving: boolean;
  saved: boolean;
  error?: string | null;
  onSave: () => void;
  commitMessage?: string;
}

export default function SaveToRepoButton({ saving, saved, error, onSave }: SaveToRepoButtonProps) {
  return (
    <div className="flex items-center gap-2 pt-2">
      <button
        onClick={onSave}
        disabled={saving}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-purple-600 text-white text-sm font-medium hover:bg-purple-700 disabled:opacity-50"
      >
        {saving ? <Spinner size="sm" tone="current" /> : <Save className="w-3.5 h-3.5" />}
        {saving ? 'Saving...' : 'Save to Repository'}
      </button>
      {saved && <span className="text-xs text-emerald-600">Saved!</span>}
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
